// This icon file is generated automatically.
var PLineChartOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.88 10.38H1.12V.62A.13.13 0 001 .5H.12A.13.13 0 000 .63v10.74c0 .07.06.13.13.13h11.74c.07 0 .13-.06.13-.13v-.87a.13.13 0 00-.13-.13zm-9.1-2.42c.05.05.12.05.17 0l2.17-2.15L7.1 7.82c.05.05.13.05.18 0l4.3-4.3a.13.13 0 000-.18l-.62-.62a.13.13 0 00-.18 0L7.2 6.32l-2-2a.13.13 0 00-.17 0L2.16 7.16a.13.13 0 000 .17l.62.62z", "fill-rule": "nonzero" } }] }, "name": "p-line-chart", "theme": "outlined" };
export default PLineChartOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PLineChartOutlined.js
// module id = 3484
// module chunks = 0